import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import css from "./Sidebar.module.css";
import { UserContext } from "../../context/UserContext";

export const AdminBar = ({ id }) => {
  const { userData } = useContext(UserContext);
  const { pathname } = useLocation();

  if (userData) {
    return (
      <div className={css.sidebar}>
        <div className={css.sidebarWrapper}>
          <div className={css.sidebarMenu}>
            <h5>{userData.displayName}</h5>
            <ul className={css.sidebarList}>
              {pathname === "/admin" ? (
                <Link to={`/admin`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>home</i>
                    Início
                  </li>
                </Link>
              ) : (
                <Link to={`/admin`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>home</i>
                    Início
                  </li>
                </Link>
              )}
              <hr />

              {pathname === "/admin/newmeeting" ? (
                <Link to={`/admin/newmeeting`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      add_circle
                    </i>
                    Nova Reunião
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/newmeeting`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      add_circle
                    </i>
                    Nova Reunião
                  </li>
                </Link>
              )}

              {pathname === "/admin/meetings" ? (
                <Link to={`/admin/meetings`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      co_present
                    </i>
                    Lista de Reuniões
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/meetings`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      co_present
                    </i>
                    Lista de Reuniões
                  </li>
                </Link>
              )}
              <hr />

              {pathname === "/admin/newact" ? (
                <Link to={`/admin/newact`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      add_circle
                    </i>
                    Nova Act
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/newact`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      add_circle
                    </i>
                    Nova Act
                  </li>
                </Link>
              )}

              {pathname === "/admin/mind" ? (
                <Link to={`/admin/mind`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      psychology
                    </i>
                    Mind
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/mind`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      psychology
                    </i>
                    Mind
                  </li>
                </Link>
              )}

              {pathname === "/admin/move" ? (
                <Link to={`/admin/move`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      accessibility
                    </i>
                    Move
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/move`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      accessibility
                    </i>
                    Move
                  </li>
                </Link>
              )}

              {pathname === "/admin/nutri" ? (
                <Link to={`/admin/nutri`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      restaurant
                    </i>
                    Nutri
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/nutri`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      restaurant
                    </i>
                    Nutri
                  </li>
                </Link>
              )}
              {pathname === "/admin/values" ? (
                <Link to={`/admin/values`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>star</i>
                    Values
                  </li>
                </Link>
              ) : (
                <Link to={`/admin/values`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>star</i>
                    Values
                  </li>
                </Link>
              )}
              <hr />
              {
                <Link to="/admin/register" className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      add_circle
                    </i>
                    Novo Usuário
                  </li>
                </Link>
              }
              {pathname === "/admin/users" ? (
                <Link to={`/admin/users`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      person
                    </i>
                    Usuários
                  </li>
                </Link>
              ) : (
                <Link to={`admin/users`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      person
                    </i>
                    Usuários
                  </li>
                </Link>
              )}
              {pathname === "/admin/registrations" ? (
                <Link to={`/admin/registrations`} className={css.link}>
                  <li className={`${css.sidebarListItem} ${css.active}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      assignment_ind
                    </i>
                    Registrations
                  </li>
                </Link>
              ) : (
                <Link to={`admin/registrations`} className={css.link}>
                  <li className={`${css.sidebarListItem}`}>
                    <i className={`material-icons ${css.sidebarIcon}`}>
                      assignment_ind
                    </i>
                    Registrations
                  </li>
                </Link>
              )}
            </ul>
          </div>

          <div
            className={`copyright ${
              userData.staff ? css.sidebarMenu : css.copyright
            } `}
          >
            ibhava.com © 2025
          </div>
        </div>
      </div>
    );
  } else if (userData) {
    return (
      <div className={css.sidebar}>
        <div className={css.sidebarWrapper}></div>
        <div className={css.sidebarMenu}>
          <h5>..., XX anos</h5>
        </div>
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
};
